<template>
  <div class="collCoupon">
    <div class="tle flex">
      <h2 class="tit-30 fw700 cor-000">领取优惠卷</h2>
    </div>

    <!-- 优惠券列表 -->
    <div class="coupon-list">
      <div
        @click="Ling(coupon)"
        v-for="(coupon, index) in coupons"
        :key="index"
        class="coupon-card cur_pointer"
      >
        <!-- 左侧金额区 -->
        <div slot="header" class="coupon-header">
          <div class="coupon-amount txt-c">
            <p class="amount tit-40 fw700 cor-fff">
              <span class="tit-18">¥</span>{{ coupon.e }}
            </p>
            <p class="condition tit-14 cor-fff">
              满{{ coupon.tiaojian }}元可用
            </p>
          </div>
        </div>
        <!-- 右侧信息区 -->
        <div class="coupon-info">
          <div :type="coupon.tagType" class="status-tag tit-14">
            立即领取
          </div>
          <div>
            <p class="title tit-18 fw700">{{ coupon.biaoti }}</p>
            <p class="valid-time tit-12">
              有效时间：{{ coupon.kaishi }}-{{ coupon.jieshu }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CouponList",
  data() {
    return {
      coupons: [
        {
          amount: 10000,
          fullCondition: 99000,
          title: "灵犀X1整机组件套餐优惠券",
          startTime: "2025/03/31",
          endTime: "2025/04/30",
          statusText: "立即领取",
          tagType: "success",
          used: false, // 标记是否已使用，实际可结合接口状态
        },

        // 可扩展更多优惠券数据...
      ],
    };
  },
  created() {
    this.CSH();
  },
  methods: {
    CSH() {
      var that = this;
      that.$post("k=quan&c=Kelingquan", function(s) {
        that.coupons = s.shu.quan;
      });
    },
    Ling(e) {
      var that = this;
      that.$post("k=quan&c=lingqu", { id: e.id }, function(s) {
        that.$xiaoxi(s.shu);
        if (s.shi == 1) {
          that.CSH();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.collCoupon {
  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.4rem;
    .coupon-card {
      background: #fafafa;
      border-radius: 0.1rem;
      width: 48%;
      margin-bottom: 0.3rem;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      min-height: 1.4rem;
      .coupon-header {
        padding: 0.2rem;
        background: linear-gradient(180deg, #41b9e0 0%, #001ff5 100%);
        height: 100%;
        display: flex;
        align-items: center;
        .amount {
          line-height: 1;
        }
      }

      .coupon-info {
        position: relative;
        height: 100%;
        padding: 0.4rem 0.2rem;
        display: flex;
        align-items: center;
        overflow: hidden;
        flex: 1;
        .status-tag {
          position: absolute;
          right: 0;
          top: 0;
          background: rgba(181, 230, 251, 0.5);
          border-radius: 0rem 0.15rem 0 0.15rem;
          color: #0e6efd;
          padding: 0.04rem 0.1rem;
        }

        .valid-time {
          margin-top: 0.1rem;
          color: #a9a9a9;
        }
      }
    }
  }
}


@media screen and (max-width: 767px) {
  .collCoupon {
    .coupon-list {
      .coupon-card {
        width: 100%;
      }
    }
  }
}


</style>
